/* eslint prefer-promise-reject-errors: ["off"] */
import uuid4 from 'uuid/v4';

import { message } from 'antd';
import { simpleAjaxDispatch, genericAjaxDispatch } from './http';
import { watchCorrelationId } from './longpoller';
import { UNKNOWN_HTTP_ERROR_MESSAGE } from '../defaults';

export function fetchOrganization(organizationId) {
  return simpleAjaxDispatch(
    `/organizations/${organizationId}`,
    'fetchOrganization',
  );
}

export function fetchControlOrganization(organizationId) {
  return simpleAjaxDispatch(
    `/organizations/${organizationId}`,
    'fetchControlOrganization',
  );
}

export function patchOrganization(organizationId, json) {
  return (dispatch, getState) => simpleAjaxDispatch(
    `/organizations/${organizationId}`,
    'patchOrganization',
    { method: 'PATCH', json },
  )(dispatch, getState).then(action => {
    if (action.success) { message.destroy(); message.success('Organization settings saved successfully'); }
    else message.warning('Couldn\'t save your organisation\'s settings right now!');
  });
}

export function patchControlOrganization(organizationId, json) {
  return (dispatch, getState) => simpleAjaxDispatch(
    `/organizations/${organizationId}/control`,
    'patchControlOrganization',
    { method: 'PATCH', json },
  )(dispatch, getState).then(action => {
    if (action.success) { message.destroy(); message.success('Organization settings saved successfully'); }
    else message.warning('Couldn\'t update this organisation\'s settings.');
  });
}

export function fetchOrganizations(query) {
  return simpleAjaxDispatch(
    `/organizations?query=${query}`,
    'fetchOrganizations',
  );
}

export function fetchOrganizationEmail(organizationId) {
  return simpleAjaxDispatch(
    `/organizations/${organizationId}/emails`,
    'fetchOrganizationEmail',
  );
}

export function postOrganizationEmail(organizationId, json) {
  return simpleAjaxDispatch(
    `/organizations/${organizationId}/emails`,
    'postOrganizationEmail',
    { method: 'POST', meta: { organizationId }, json },
  );
}

export function patchDefineTypeRequestForOrg(organizationId) {
  return simpleAjaxDispatch(
    `/organizations/${organizationId}/define_types_requests`,
    'patchDefineTypeRequestForOrg',
    { method: 'PATCH', meta: { organizationId } },
  );
}

export function postPoliceCheckRequestForOrg(organizationId) {
  return (dispatch, getState) => simpleAjaxDispatch(
    `/organizations/${organizationId}/police_check_request`,
    'postPoliceCheckRequestForOrg',
    { method: 'POST', meta: { organizationId } },
  )(dispatch, getState).then(action => {
    if (action.success) message.success('Police Checks requested successfully');
    else message.warning('Couldn\'t request Police Checks for this organisation');
  });
}

export function postOrganizationCredentials(organizationId, json) {
  const allData = { ...json, correlationId: uuid4() };
  let finalValue = null;
  return (dispatch, getState) => new Promise((resolve, reject) => {
    const watchProm = watchCorrelationId(allData.correlationId, (err, value) => {
      if (err) return;
      // routingKey is like event.rpc.result.<ev>.<qualName>
      const event = value.routingKey.split('.')[3];
      if (event === 'complete') {
        if (finalValue) {
          if (finalValue.event === 'value') {
            resolve(finalValue.content);
          } else if (finalValue.event === 'error') {
            reject(finalValue.content);
          } else {
            reject({ _errors: [UNKNOWN_HTTP_ERROR_MESSAGE] });
          }
        } else {
          reject({ _errors: [UNKNOWN_HTTP_ERROR_MESSAGE] });
        }
      } else {
        finalValue = value;
        finalValue.event = event;
      }
    })
      .then(() => {
        simpleAjaxDispatch(`/organizations/${organizationId}/institutions/credentials`, 'postOrganizationCredentials', {
          json: allData, method: 'POST', meta: { organizationId },
        })(dispatch, getState)
          .then(action => {
            if (action.failed) {
              reject(action.data);
            }
          })
          .catch(err => reject({ _errors: [err] }))
          .finally(() => watchProm.cancel());
      })
      .catch(() => { });
  });
}

export function fetchCurrentOrganization() {
  return simpleAjaxDispatch(
    '/organizations/me',
    'fetchCurrentOrganization',
  );
}

export function fetchOrganizationSettings() {
  return simpleAjaxDispatch(
    '/organizations/settings',
    'fetchOrganizationSettings',
  );
}

export function fetchOrganizationSettingsV2(organizationId) {
  return simpleAjaxDispatch(
    `/organizations/${organizationId}/settings`,
    'fetchOrganizationSettingsV2',
  );
}

export function patchOrganizationSettingsV2(organizationId, json) {
  return (dispatch, getState) => simpleAjaxDispatch(
    `/organizations/${organizationId}/settings`,
    'patchOrganizationSettingsV2',
    { method: 'PATCH', json },
  )(dispatch, getState).then(action => {
    if (action.success) { message.destroy(); message.success('Organization settings saved successfully'); }
    else message.warning('Couldn\'t update this organisation\'s settings.');
  });
}

export function fetchNCCOauthUrl() {
  return simpleAjaxDispatch(
    '/oauth/ncc/authorize',
    'fetchNCCOauthUrl',
  );
}

export function fetchNCCOPingUrl() {
  return simpleAjaxDispatch(
    '/oauth/ncc/ping',
    'fetchNCCOauthUrl',
  );
}

export function postOrganizationQldDefaults(organizationId, json) {
  return simpleAjaxDispatch(`/organizations/${organizationId}/institutions/qldblue/defaults`, 'postOrganizationQldblueDefaults', {
    json, method: 'POST', meta: { organizationId },
  });
}

export function postOrganizationNDWSDefaults(organizationId, json) {
  return simpleAjaxDispatch(`/organizations/${organizationId}/settings/ndws/defaults`, 'postOrganizationNDWSDefaults', {
    json, method: 'POST', meta: { organizationId },
  });
}

export function postOrganizationNSWOneTimeCheckDefaults(organizationId, json) {
  return simpleAjaxDispatch(`/organizations/${organizationId}/settings/nsw_otc/defaults`, 'postOrganizationNSWDOneTimeCheckDefaults', {
    json, method: 'POST', meta: { organizationId },
  });
}

export function fetchAdminOrganizationSettings(organizationId) {
  return simpleAjaxDispatch(
    `/admin/organization/settings?organization_id=${organizationId}`,
    'fetchAdminOrganizationSettings',
  );
}

export function patchAdminOrganizationSettings(settings) {
  return (dispatch, getState) => simpleAjaxDispatch(
    '/admin/organization/settings',
    'patchAdminOrganizationSettings',
    { method: 'PATCH', json: { settings } },
  )(dispatch, getState).then(action =>
    // Return the action so the component can handle success/error display
    action);
}

export function deleteAdminOrganizationSetting(organizationId, key) {
  return (dispatch, getState) => simpleAjaxDispatch(
    `/admin/organization/settings?organization_id=${organizationId}&key=${key}`,
    'deleteAdminOrganizationSetting',
    { method: 'DELETE' },
  )(dispatch, getState).then(action =>
    // Return the action so the component can handle success/error display
    action);
}

export function fetchAdminOrganizationById(organizationId) {
  return simpleAjaxDispatch(
    `/organizations/${organizationId}`,
    'fetchAdminOrganizationById',
  );
}

export function fetchAdminOrganizationUserRoles(organizationId) {
  return simpleAjaxDispatch(
    `/admin/organization/user/roles?organization_id=${organizationId}`,
    'fetchAdminOrganizationUserRoles',
  );
}

export function patchAdminOrganizationUserRoles(userId, data) {
  return (dispatch, getState) => simpleAjaxDispatch(
    '/admin/organization/user/roles',
    'patchAdminOrganizationUserRoles',
    { method: 'PATCH', json: { user_id: userId, ...data } },
  )(dispatch, getState).then(action => action);
}

export function deleteAdminOrganizationUserRoles(userId, roles) {
  return (dispatch, getState) => simpleAjaxDispatch(
    '/admin/organization/user/roles',
    'deleteAdminOrganizationUserRoles',
    { method: 'DELETE', json: { user_id: userId, roles } },
  )(dispatch, getState).then(action => action);
}

export function patchAdminAccredRescanInfo(json) {
  return (dispatch, getState) => simpleAjaxDispatch(
    '/admin/organization/accred/rescan/info',
    'patchAdminAccredRescanInfo',
    { method: 'PATCH', json },
  )(dispatch, getState).then(action => {
    if (action.success) { message.destroy(); message.success('Rescan info updated successfully'); }
    else message.warning('Couldn\'t update rescan info.');
    return action;
  });
}

export function postAdminAccredRescanInfo(json) {
  return (dispatch, getState) => simpleAjaxDispatch(
    '/admin/organization/accred/rescan/info',
    'postAdminAccredRescanInfo',
    { method: 'POST', json },
  )(dispatch, getState).then(action => {
    if (action.success) { message.destroy(); message.success('Rescan entry created successfully'); }
    else message.warning('Couldn\'t create rescan entry.');
    return action;
  });
}

export function deleteAdminAccredRescanInfo(json) {
  return (dispatch, getState) => simpleAjaxDispatch(
    '/admin/organization/accred/rescan/info',
    'deleteAdminAccredRescanInfo',
    { method: 'DELETE', json },
  )(dispatch, getState).then(action => {
    if (action.success) { message.destroy(); message.success('Rescan entry deleted successfully'); }
    else message.warning('Couldn\'t delete rescan entry.');
    return action;
  });
}

export function fetchAdminAccredRescanInfo(organizationId) {
  return simpleAjaxDispatch(
    `/admin/organization/accred/rescan/info?organization_id=${organizationId}`,
    'fetchAdminAccredRescanInfo',
  );
}

export function uploadOrganizationLogo(file, organizationId) {
  return (dispatch, getState) => new Promise((resolve, reject) => {
    // Step 1: Get pre-signed upload URL from backend
    genericAjaxDispatch(
      dispatch, getState, `/organizations/${organizationId}/logo/upload`,
      'uploadOrganizationLogoAuthorize',
      {
        method: 'POST',
        json: { filename: file.name, content_type: file.type },
        responseSnake: false,
      },
    ).then(
      authAction => {
        if (authAction.data._errors) return reject(authAction.data._errors);

        // Step 2: Upload file to S3 using pre-signed URL
        const formData = new FormData();
        Object.entries(authAction.data.upload.fields).forEach(
          ([key, value]) => formData.append(key, value),
        );
        formData.append('file', file);

        genericAjaxDispatch(
          dispatch, getState,
          authAction.data.upload.url,
          'uploadOrganizationLogo',
          {
            method: 'POST',
            body: formData,
            auth: false,
            meta: authAction.data,
          },
        ).then(uploadAction => {
          // Check if S3 upload succeeded
          if (uploadAction.failed) {
            const errorMessage = uploadAction.body || 'Failed to upload logo to S3';
            return reject(new Error(errorMessage));
          }

          // Return the uploaded file URL
          resolve({
            success: true,
            data: {
              url: authAction.data.url || `${authAction.data.upload.url}/${authAction.data.upload.fields.key}`,
            },
          });
        }, reject);
      }, reject,
    );
  });
}
